import React from 'react';
import {
    Box,
    Card,
    CardActionArea,
    Stack,
    Typography
} from "@mui/material";
import { ArrowBackRounded } from "@mui/icons-material";

const _DashCatItem = ({ icon, header, title, soon, description, onClick }) => {
    return (
        <Card
            sx={{
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                boxShadow: '0 2px 12px rgba(0, 0, 0, 0.03)',
                height: '100%',
                position: 'relative',
                overflow: 'hidden',
                transition: 'all 0.28s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                    transform: 'translateY(-3px)',
                    boxShadow: '0 12px 28px rgba(0, 0, 0, 0.08)',
                    borderColor: 'primary.main',
                    '& .arrow-icon': {
                        transform: 'translateX(-4px)',
                        color: 'primary.main',
                    }
                }
            }}
        >
            <CardActionArea
                onClick={onClick}
                sx={{
                    p: 2.5,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                }}
            >
                <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                    <Box
                        sx={{
                            width: 52,
                            height: 52,
                            borderRadius: 3,
                            bgcolor: 'rgba(28, 139, 156, 0.08)',
                            color: 'primary.main',
                            p: 1.1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: 'inset 0 0 0 1px rgba(28, 139, 156, 0.12)',
                            '& img': {
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain'
                            }
                        }}
                    >
                        {icon}
                    </Box>

                    <ArrowBackRounded
                        className="arrow-icon"
                        sx={{
                            fontSize: 18,
                            color: 'text.disabled',
                            transition: 'all 0.25s ease'
                        }}
                    />
                </Box>

                <Box sx={{ width: '100%' }}>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 800,
                            fontSize: '1.05rem',
                            color: 'text.primary',
                            mb: 0.6,
                        }}
                    >
                        {title}
                    </Typography>

                    {description && (
                        <Typography
                            variant="body2"
                            sx={{
                                color: 'text.secondary',
                                lineHeight: 1.7,
                                display: 'block',
                                textAlign: 'justify',
                                textJustify: 'inter-word',
                                fontSize: '0.82rem',
                            }}
                        >
                            {description}
                        </Typography>
                    )}
                </Box>
            </CardActionArea>
        </Card>
    );
};

export default _DashCatItem;
